import { VALIDATION_MESSAGES, REGEX_PATTERNS } from 'eebac/constants';


const FIELDS = {
    companyType: {
        type: "select",
        label: "Company Type",
        isRequired: true,
        options: [],
        isLoading: false,
        xs:12,
        lg:3,
        sm:6,
        md:3,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
        }
    },
    projectName: {
        type: "input",
        label: "Project Name",
        isRequired: false,
        xs:12,
        lg:3,
        sm:6,
        md:3,
        validations: {
            length: {
                minimum: 2, maximum: 255
            }
        }
    },
    projectLocation: {
        type: "input",
        label: "Project Location",
        isRequired: false,
        xs:12,
        lg:3,
        sm:6,
        md:3,
        validations: {
            length: {
                minimum: 2, maximum: 255
            }
        }
    },
};

export default FIELDS;